import Cookies from 'js-cookie';

export const getWebUserType = () => {
  let shop_data = '';
  if (!Cookies.get('shopData')) {
    shop_data = Math.abs(Math.floor(1 + Math.random() * 2)) == 1 ? 'A' : 'B';
    const userTypeObj = {
      userType: shop_data,
    };
    Cookies.set('shopData', JSON.stringify(userTypeObj), {
      expires: 365,
      path: '/',
    });
  } else {
    if (Cookies.get('shopData').includes('{')) {
      shop_data = JSON.parse(Cookies.get('shopData'))?.userType;
    } else {
      shop_data = Cookies.get('shopData');
    }
  }
  return shop_data;
};
